import Vue from 'vue'
import config from '../config'
import { Capacitor } from "@capacitor/core";
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('30d')

var cloneDeep = require('lodash.clonedeep');

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  return false;
})

Vue.prototype.$config = config

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

String.prototype.getInitials = function(glue){
       var name = this;
      if (!name) name = "NOT";
      var initials = name.match(/\b\w/g) || [];
      return ((initials.shift() || "") + (initials.pop() || "")).toUpperCase();
};

Vue.filter('toCurrency', function (value) {
    try {
        if (typeof value === "string") value = parseFloat(value.replace(',','.'))
    }catch(e){
        return value
    }
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

Vue.mixin({
    data() {
        return {
          message: null          
        };
      },
    computed: {
        showMessage: {
            get() {
              return this.message ? true : false
            },
            set(value){
              this.message = null
            }
          },
          isWeb(){
            return !this.isNative
            //return window.matchMedia('(display-mode: standalone)').matches ? false: true //!this.$vuetify.breakpoint.mobile
          },
          largeScreen(){
            return this.$vuetify.breakpoint.width > this.$config.page.width
          },
          platform(){
          // return 'ios'
            return Capacitor.getPlatform() 
          },
          isNative(){
            return Capacitor.isNativePlatform() 
          }
    },
    methods: {
        addMessage(message,type,color){
            this.message = {text: message, type: type || 'info', color: color || 'primary'}
        },
        clone(obj){
            return cloneDeep(obj)
        },
        async notifyOffice(message, type){
              if (!this.$store.state.user) return alert('Error')
              if (!this.$store.state.user.phone) return alert('Error')
              if (!type) type = 'administrator'
              this.$http.post('/api/services/notify/' + type,
              {
                phone: this.$store.state.user.phone,
                message: message
              })
        },
        async openUrl(url, listener){
          console.log(url)
          if (Capacitor.isNativePlatform()){
            if (listener == true){
                Browser.addListener("browserFinished", (info) => {
                    this.loading = false
                    this.$router.push({path: '/' + order._id})
                  })
                }
              let w = await Browser.open({ url: url });
            return w
        }else{
              return window.open(url)
          }
        },
        _config(type,value){
          let setting = this.$config[type]
          if (!setting || !value) return {}
          if (setting[value]) return setting[value]
          if (value.split && setting[value.split('-')[0]]) return setting[value.split('-')[0]]
          if (Array.isArray(setting)){
              return setting.filter(s=>s.value==value)[0] || {}
          }
          return setting.default || {}
      },
    }
  })

export const EventBus = new Vue();
Vue.prototype.$events = EventBus

